import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import IconButton from "@material-ui/core/IconButton";
import Notifications from "@material-ui/icons/Notifications";
import NotificationsModal from "./NotificationsModal";
import { STNotificationText } from "./styles";
import { INotificationsStore } from "../Stores/NotificationsStore";
import { NotificationsConfiguration } from "../WebSockets/WsConfiguration";
import { StylesProvider, createGenerateClassName } from "@material-ui/core";
import { ISharedValues } from "../Stores/SharedValuesStore";

interface IProps {
  configuration: NotificationsConfiguration;
  notifications?: INotificationsStore;
  sharedValues?: ISharedValues;
}

const generateClassName = createGenerateClassName({
  productionPrefix: "notification",
  disableGlobal: true,
  seed: "notification",
});

@inject("notifications", "sharedValues")
@observer
export default class NotificationsButton extends React.Component<IProps> {
  @observable isOpened: boolean = false;
  @observable anchorEl: HTMLElement;

  handleClose = () => {
    this.isOpened = false;
  };

  handleOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.isOpened = true;
    this.anchorEl = event.currentTarget;
  };

  render() {
    const userManagementUrl = this.props.sharedValues.userManagementUrl;
    return (
      <StylesProvider injectFirst generateClassName={generateClassName}>
        <IconButton
          aria-owns={this.isOpened ? this.props.configuration.ariaOwns : undefined}
          aria-haspopup="true"
          color="inherit"
          onClick={this.handleOpen}
        >
          <Notifications />
          {this.props.notifications.lastUnreadNotifications.length > 0 ? <STNotificationText /> : null}
        </IconButton>
        <audio className="audio-element">
          <source src={`${userManagementUrl}sounds/notification.mp3`}></source>
        </audio>
        <NotificationsModal isOpened={this.isOpened} onClose={this.handleClose} anchorEl={this.anchorEl} />
      </StylesProvider>
    );
  }
}
